export const extractDataFromResponse = (response) => {
  const { headers } = response

  return Object.assign(response.data, {
    headers: {
      'access-token': headers['access-token'],
      'token-type': headers['token-type'],
      'client': headers['client'],
      'expiry': headers['expiry'],
      'uid': headers['uid']
    }
  })
}

export default { extractDataFromResponse }
